import { apiRequest, deleteResource, getResource } from "../api/http";

export function getSliderBySliderType(sliderType) {
  const languageCode = localStorage.getItem("lang");
  return getResource(
    `/api/sliders/get-slider-by-slider-type/${sliderType}/${languageCode}`,
    { select: (data) => data.allSliders, fallback: [] }
  );
}

export function getMovieVideoSlides() {
  return getResource("/api/sliders/get-movie-list");
}

export function getShowPodcastSlides() {
  return getResource("/api/sliders/get-show-list");
}

export function addItemToSlider(obj) {
  return apiRequest("post", "/api/sliders/add-slider-item", { data: obj });
}

export function deleteSliderItem(_id) {
  return deleteResource(`/api/sliders/delete-slider-item-by-id/${_id}`);
}
